import React from 'react';
import LogTable from 'components/atoms/log-table';
import { useStatusLog } from 'infrastructure/hooks/logs/use-status-log';
import useUpdateEffect from 'infrastructure/hooks/utils/use-update-effect';

import type { DateRange } from 'infrastructure/types';

interface IPatientStatusLogProps {
  patientGuid: string;
  dateRange?: DateRange;
}

const PatientStatusLog: React.FC<IPatientStatusLogProps> = (props) => {
  const { patientGuid, dateRange } = props;

  const { loading, meta, items, setMeta } = useStatusLog({
    patientGuid,
    meta: {
      dateRange,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
      dateRange,
    });
  };

  useUpdateEffect(() => {
    setMeta({
      ...meta,
      page: 1,
      dateRange,
    });
  }, [dateRange]);

  return (
    <LogTable
      dataCy="patient-status-log-table"
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomRight'],
      }}
      onChangePage={onChangePage}
    />
  );
};

export default PatientStatusLog;
